import { call, select } from 'redux-saga/effects';

import { getOrderAppointments } from 'features/order-tracker/api/orderTrackerApi';
import { getCurrentAppointmentInfoToAmend } from 'features/order-tracker/store/selectors';

export function* getOrderPreAppointmentsRequest(date: string, isInitRequest?: boolean) {
  const { itemId, orderKey } = yield select(getCurrentAppointmentInfoToAmend);

  return yield call(getOrderAppointments, orderKey, itemId, date, isInitRequest);
}
